import { RouteNames } from 'constants/routeNames'
import OnBoarding from './pages/OnBoarding'

//@todo: added other inner pages to routes
export default {
  routes: [
    {
      key: 'ONBOARDING_STEP',
      title: 'OnBoarding',
      type: 'public',
      path: `/${RouteNames.ONBOARDING}/step/:id`,
      component: OnBoarding,
      exact: true,
    },
    {
      key: 'ONBOARDING',
      title: 'OnBoarding',
      type: 'public',
      path: `/${RouteNames.ONBOARDING}`,
      component: OnBoarding,
      exact: true,
    },
  ],
}
